/**
 * Manages the social menus.
 */

import {moveIconsIntoDom} from './dom.js';

// console.log('Site:social');

// Find all social menus and move the SVG content inside each link's ::after into the DOM
moveIconsIntoDom(jQuery('#footer .menu-social-container'));
moveIconsIntoDom(jQuery('#sticky-header-social-menu'));
